import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ChoiceChips from 'components/Form/choiceChips';
import DateInput from 'components/Form/dateInput';
import FilterDrawerShell from 'components/Form/filterDrawerShell';
import FilterSection, { FilterField } from 'components/Form/filterSection';
import FilterSelect from "components/Form/filterSelect";
import { countActive, filterValueOf, resolveMultiValue } from 'components/Form/filterValues';
import { leaveStatusOptions } from 'utils/constants';

const SECTION_KEYS = {
  claim: ["reference_date", "posting_date", "approval_status"],
  people: ["company_user", "current_approver"],
};

const FilterDrawer = ({
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleApplyFilter,
    filterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty
}) => {
  const { userData, userDataLoading } = useSelector((state) => state.common);
  const [userDataOption, setUserDataOption] = useState([]);
  useEffect(() => {
    setUserDataOption((userData || []).map(item => ({ label: `${item.first_name} ${item.last_name || ""}`.trim(), value: item.id, emp_no: item.emp_no })));
  }, [userData]);

  const valueOf = (key) => filterValueOf(filters, key);

  return (
    <FilterDrawerShell
      open={showFilterDrawer}
      onClose={handleFilterDrawer}
      activeCount={countActive(filters, Object.values(SECTION_KEYS).flat())}
      onClearAll={handleClearAll}
      onApply={handleApplyFilter}
      applying={filterLoading}
      applyDisabled={!isFilterDirty}
    >
      <FilterSection title="Claim" count={countActive(filters, SECTION_KEYS.claim)}>
        <FilterField label="Dates">
          <div className="date-range">
            <DateInput id="reference_date" label="Reference date" value={valueOf("reference_date") || ""} onChange={e=>{handleDateChange(e.target.value, "reference_date")}} />
            <DateInput id="posting_date" label="Posting date" value={valueOf("posting_date") || ""} onChange={e=>{handleDateChange(e.target.value, "posting_date")}} />
          </div>
        </FilterField>
        <FilterField label="Approval status">
          <ChoiceChips ariaLabel="Approval status" options={leaveStatusOptions} value={valueOf("approval_status")} onChange={(option) => handleFilterChange(option, "approval_status")} />
        </FilterField>
      </FilterSection>

      <FilterSection title="People" count={countActive(filters, SECTION_KEYS.people)}>
        <FilterField label="Employee" hint="one or more" htmlFor="filter-expense-user">
          <FilterSelect inputId="filter-expense-user" isMulti={true} checkboxMenu={true} maxVisibleValues={2} menuPosition="fixed" isClearable={true} onChange={e=>{handleFilterChange(e, "company_user")}} optionLabel={"label"} optionValue={'value'} options={userDataOption} isLoading={userDataLoading} value={resolveMultiValue(valueOf("company_user"), userDataOption)} placeholder={"Any"}/>
        </FilterField>
        <FilterField label="Current approver" hint="one or more" htmlFor="filter-expense-approver">
          <FilterSelect inputId="filter-expense-approver" isMulti={true} checkboxMenu={true} maxVisibleValues={2} menuPosition="fixed" isClearable={true} onChange={e=>{handleFilterChange(e, "current_approver")}} optionLabel={"label"} optionValue={'value'} options={userDataOption} isLoading={userDataLoading} value={resolveMultiValue(valueOf("current_approver"), userDataOption)} placeholder={"Any"}/>
        </FilterField>
      </FilterSection>
    </FilterDrawerShell>
  );
};
export default FilterDrawer;
